var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'player_unban', params: {playerId: _vm.playerId, unbanId: _vm.unbanId}}}},[_vm._v("\n  "+_vm._s(_vm.lable)+" "+_vm._s(_vm.unbanId)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }